import { render, staticRenderFns } from "./BusinessInfoCard.vue?vue&type=template&id=78644a84&"
import script from "./BusinessInfoCard.vue?vue&type=script&lang=js&"
export * from "./BusinessInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./BusinessInfoCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports